import React from 'react';
import { AlertTriangle, Wrench, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface MaintenancePageProps {
  title?: string;
  message?: string;
}

export const MaintenancePage: React.FC<MaintenancePageProps> = ({
  title = 'Maintenance Mode',
  message = 'Aplikasi sedang dalam perbaikan. Silakan coba lagi nanti.'
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        {/* Animated Icon */}
        <div className="relative mb-8">
          <div className="w-32 h-32 mx-auto bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center shadow-2xl animate-pulse">
            <Wrench className="w-16 h-16 text-white" />
          </div>
          <div className="absolute -top-2 -right-2 w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center animate-bounce shadow-lg">
            <AlertTriangle className="w-6 h-6 text-yellow-900" />
          </div>
        </div>
        
        {/* Title */}
        <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-4">
          {title}
        </h1>
        
        {/* Message */}
        <p className="text-gray-600 dark:text-gray-300 mb-8 text-lg leading-relaxed">
          {message}
        </p>
        
        {/* Decorative Elements */}
        <div className="flex justify-center gap-2 mb-8">
          <div className="w-3 h-3 rounded-full bg-amber-400 animate-bounce" style={{ animationDelay: '0ms' }} />
          <div className="w-3 h-3 rounded-full bg-orange-400 animate-bounce" style={{ animationDelay: '150ms' }} />
          <div className="w-3 h-3 rounded-full bg-yellow-400 animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>
        
        {/* Refresh Button */}
        <Button 
          onClick={() => window.location.reload()} 
          variant="outline"
          className="gap-2 bg-white/80 dark:bg-gray-800/80 hover:bg-white dark:hover:bg-gray-800"
        >
          <RefreshCw className="w-4 h-4" />
          Coba Lagi
        </Button>
        
        {/* Company Logo */}
        <div className="mt-12 opacity-60">
          <img 
            src="/lovable-uploads/f6cd4aef-9488-423f-83b9-406abaa28823.png" 
            alt="Logo" 
            className="w-12 h-12 mx-auto object-contain"
          />
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">
            PT. Gemilang Cipta Wawasan
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
